import React from "react"
import PropTypes from "prop-types"
import {
  Heading,
  Container,
  UnorderedList,
  ListItem,
  Button,
  Flex,
  Box,
  Text,
  useColorMode,
} from "@chakra-ui/react"
import { FormattedMessage, Link } from "gatsby-plugin-intl"
import Img from "gatsby-image"
import SEO from "../components/seo"
import Layout from "../components/layout"
import { graphql } from "gatsby"

const Index = ({ data, location }) => {
  const { colorMode } = useColorMode()
  const isLight = colorMode === "light"
  return (
    <>
      <Layout location={location}>
        <SEO title="HjemJobbHjem" />
        <Box className="sc-index-page-wrapper">
          <Box
            paddingTop={["100px", "170px", "250px", "300px"]}
            paddingBottom={["160px", "170px", "250px", "600px"]}
            className="sc-index-page-title"
          >
            <Box maxWidth="1200px" marginLeft="auto" marginRight="auto">
              <Heading
                paddingLeft="10"
                paddingRight="10"
                fontSize={["30px", "40px", "40px", "60px"]}
                textShadow=" 1px 1px 20px black"
              >
                SCUSHI HjemJobbHjem
              </Heading>
            </Box>
          </Box>
        </Box>

        <Box className="sc-index-page-info" paddingBottom="20">
          <Flex
            maxWidth="1200px"
            marginLeft="auto"
            marginRight="auto"
            direction={["column", "column", "row", "row"]}
            className="sc-index-page-info-content"
            boxShadow="2xl"
            padding={["30px", "50px", "20", "20"]}
            background={isLight ? "white" : "gray.800"}
          >
            <Box
              flex="1"
              paddingRight={["0", "0", "20", "20"]}
              paddingTop={["10", "10", "10", "0"]}
            >
              <Text fontSize="xl">
                <FormattedMessage id="indexInfo1" />
              </Text>
              <Text fontSize="xl" marginTop="10">
                <FormattedMessage id="indexInfo2" />
              </Text>
            </Box>
            <Box
              flex="1"
              paddingTop={["10", "10", "0", "0"]}
              paddingBottom={["10", "10", "10", "0"]}
            >
              <Img
                fluid={data.frontimage1?.childImageSharp.fluid}
                alt=""
                style={{ borderRadius: "20px" }}
              />
            </Box>
          </Flex>
        </Box>

        <Container marginBottom="40" marginTop="40">
          <Heading size="xl">
            <FormattedMessage id="indexHowItWorks" />
          </Heading>
          <UnorderedList marginTop="5">
            <ListItem fontSize="xl">
              <FormattedMessage id="indexChooseBike" />
            </ListItem>
            <ListItem fontSize="xl">
              <FormattedMessage id="indexChooseSize" />
            </ListItem>
            <ListItem fontSize="xl">
              <FormattedMessage id="indexBuyOrLease" />
            </ListItem>
            <ListItem fontSize="xl">
              <FormattedMessage id="indexFillOut" />
            </ListItem>
            <ListItem fontSize="xl">
              <FormattedMessage id="indexOrderBike" />
            </ListItem>
          </UnorderedList>
          <Link to="/bikes">
            <Button variant="solid" marginTop="7" size="lg">
              <FormattedMessage id="indexGetStartedButton" />
            </Button>
          </Link>
        </Container>

        <Box
          paddingBottom="20"
          maxWidth="1200px"
          marginLeft="auto"
          marginRight="auto"
        >
          <Heading size="lg" paddingLeft="20px" paddingRight="20px">
            <FormattedMessage id="indexShopsTitle" />
          </Heading>
          <Flex direction={["column", "column", "row", "row"]}>
            <Box flex="1" paddingRight={["0", "0", "20", "20"]}>
              <Container
                marginBottom="10"
                marginTop="10"
                boxShadow="2xl"
                borderRadius="20px"
                padding="5"
              >
                <Img
                  fluid={data.byaasen?.childImageSharp.fluid}
                  alt=""
                  style={{ borderRadius: "20px" }}
                />
                <Box paddingTop="5">
                  <Heading marginBottom="5">SCUSHI Byåsen</Heading>
                  <Text>Fjellseterveien 1, 7020 Trondheim</Text>
                  <Text>97 303 675</Text>
                  <Text>byasen@scushi.no</Text>
                </Box>
                <Box marginTop="5">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1785.3629903492479!2d10.349837916284354!3d63.41789668374096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x466d33c7a1e9a00f%3A0x26001e7bac0e006c!2sScushi%20By%C3%A5sen!5e0!3m2!1sno!2sno!4v1611698805554!5m2!1sno!2sno"
                    frameBorder="0"
                    style={{
                      border: 0,
                      width: "100%",
                      height: "400px",
                      borderRadius: "20px",
                    }}
                    allowFullScreen=""
                    aria-hidden="false"
                    tabIndex="0"
                  ></iframe>
                </Box>
              </Container>
            </Box>
            <Box flex="1" paddingTop={["10", "10", "0", "0"]}>
              <Container
                marginBottom="10"
                marginTop="10"
                boxShadow="2xl"
                borderRadius="20px"
                padding="5"
              >
                <Img
                  fluid={data.valentinlyst?.childImageSharp.fluid}
                  alt=""
                  style={{ borderRadius: "20px" }}
                />
                <Box paddingTop="5">
                  <Heading marginBottom="5">SCUSHI Valentinlyst</Heading>
                  <Text>Anders Estenstads veg 20, 7046 Trondheim</Text>
                  <Text>94 10 5440</Text>
                  <Text>valentinlyst@scushi.no</Text>
                </Box>
                <Box marginTop="5">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7139.762074019653!2d10.4417107!3d63.4246805!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x57b3ad7793762fd0!2sSCUSHI%20Trondheim!5e0!3m2!1sno!2sno!4v1611698664847!5m2!1sno!2sno"
                    frameBorder="0"
                    style={{
                      border: 0,
                      width: "100%",
                      height: "400px",
                      borderRadius: "20px",
                    }}
                    allowFullScreen=""
                    aria-hidden="false"
                    tabIndex="0"
                  ></iframe>
                </Box>
              </Container>
            </Box>
          </Flex>
        </Box>
      </Layout>
    </>
  )
}

Index.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
}

export default Index

export const query = graphql`
  query {
    frontimage1: file(relativePath: { eq: "frontimage2.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    byaasen: file(relativePath: { eq: "byåsen.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    valentinlyst: file(relativePath: { eq: "valentinlyst.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`
